export const setSearchData = (data) => ({
    type: 'SET_SEARCH_DATA',
    payload: data,
  });
  